//页面三级权限
import { mapState } from 'vuex';

export default {
  data() {
    return {
      operations: [],
      noChildMunuList: ['']
    };
  },
  created() {
    this.getOperation();
  },
  computed: {
    ...mapState(['operationList'])
  },
  methods: {
    getOperation() {
      const { meta } = this.$route;
      this.operationList.forEach(item => {
        if (meta.length > 1) {
          if (!this.noChildMunuList.includes(item.name) && meta[meta.length - 1].name === item.name) {
            this.operations = item.operations.map(val => val.menu_name);
            console.log(this.operations, 'operations');
          } else if (this.noChildMunuList.includes(item.name) && meta[0].name === item.name) {
            this.operations = item.operations.map(val => val.menu_name);
            console.log(this.operations, 'operations1');
          }
        }
      });
    }
  }
};